import { useEffect, useState } from "react";
import { leadMailThread } from "../../services/crmServices/mailService";
import moment from "moment";

export function MailActivity({ leadId, onOpen }) {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (!leadId) return;
        let cancelled = false;
        leadMailThread(leadId)
            .then((res) => {
                if (!cancelled) setRows(res.data || []);
            })
            .catch(() => {
                if (!cancelled) setRows([]);
            });
        return () => {
            cancelled = true;
        };
    }, [leadId]);

    if (!rows.length) return null;

    return (
        <div className="border border-gray-200 rounded-md bg-white">
            <div className="px-3 py-2 border-b text-xs font-semibold text-gray-600">Emails</div>
            <div className="max-h-48 overflow-y-auto divide-y">
                {rows.slice(0, 8).map((m) => (
                    <button
                        key={m._id}
                        type="button"
                        onClick={() => onOpen?.(m)}
                        className="w-full text-left px-3 py-2 hover:bg-gray-50"
                    >
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-xs font-medium truncate">
                                {m.direction === "inbound" ? "← " : "→ "}
                                {m.subject || "(no subject)"}
                            </span>
                            <span className="text-[10px] text-gray-400 shrink-0">
                                {moment(m.sentAt || m.createdAt).format("MMM D HH:mm")}
                            </span>
                        </div>
                        <p className="text-[11px] text-gray-400 truncate">
                            {m.status === "sent" && m.opens?.length ? `${m.opens.length} open${m.opens.length > 1 ? "s" : ""}` : m.status}
                        </p>
                    </button>
                ))}
            </div>
        </div>
    );
}
